import {ENABLE_MERIE_REPORTS, ENABLE_PH_REC} from '@wallaby-ui/core';

export default {
  appName: 'MERIE',
  index: '/hospitalizedPatients',
  loadingComponent: 'LoadingSpinnerPage',
  notFoundComponent: 'NotFoundComponentBox',
  staticGroups: [
    {
      id: 'general',
      label: 'navigation.section.merie',
    },
    // its pages need the Use alerts right, so without it the whole section, heading included, stays hidden
    {
      id: 'alerts',
      label: 'navigation.section.merieAlerts',
    },
    {
      id: 'reports',
      label: 'navigation.section.meriereports',
    },
  ],
  staticRoutes: [
    {
      path: '/hospitalizedPatients',
      component: 'HospitalizedPatientsLayout',
      label: 'navigation.route.hospitalizedPatients',
      iconName: 'merieHospitalizationsIcon',
      group: 'general',
    },
    ...(ENABLE_MERIE_REPORTS
      ? [
          {
            path: '/hospitalNetworkReport',
            component: 'MerieHospitalNetworkReportLayout',
            label: 'navigation.route.hospitalNetworkReportMerie',
            iconName: 'haidiHospitalGroupReportIcon',
            group: 'reports',
            roles: ['DEPARTMENT:MULTI_HOSPITAL'],
          },
          {
            path: '/hospitalReport',
            component: 'MerieHospitalReportLayout',
            label: 'navigation.route.hospitalReportMerie',
            iconName: 'haidiHospitalReportIcon',
            group: 'reports',
          },
          {
            path: '/departmentReport',
            component: 'MerieDepartmentReportLayout',
            label: 'navigation.route.departmentReportMerie',
            iconName: 'analytics1',
            group: 'reports',
          },
          {
            path: '/uzisReport',
            component: 'MerieUzisReportLayout',
            label: 'navigation.route.uzisReportMerie',
            iconName: 'analytics2',
            group: 'reports',
            instanceLocations: ['CZ'],
          },
        ]
      : []),
    ...(ENABLE_PH_REC
      ? [
          {
            path: '/pharmacotherapyRecommendationList',
            component: 'PhRecommendationListLayout',
            label: 'navigation.route.pharmacotherapyRecommendationList',
            iconName: 'haidiHaiListIcon',
            group: 'general',
          },
        ]
      : []),
    // NOTE: the two alert icons are taller than wide, so each gets a square viewBox starting at the glyph's left edge:
    // full 12 px height, left edge on the menu's icon line, like the 12x12 icons of the other items (PDW-409)
    // the alerts list (PDW-183), only for a user with the Use alerts right, as its endpoint requires
    {
      path: '/alertList',
      component: 'AlertListLayout',
      label: 'navigation.route.alertList',
      // glyph spans x 1..15, y 0.31..16.31 of its 16x17 canvas
      iconName: 'listIcon',
      iconViewbox: '1 0.31 16 16',
      group: 'alerts',
      roles: ['ALERT_USE_ROLE'],
    },
    // the alert board (PDW-184), only for a user with the Use alerts right, as its endpoint requires
    {
      path: '/alertBoard',
      component: 'AlertBoardLayout',
      label: 'navigation.route.alertBoard',
      // the saved filters' alert bell (Font Awesome 448x512)
      iconName: 'bellIcon',
      iconViewbox: '0 0 512 512',
      group: 'alerts',
      roles: ['ALERT_USE_ROLE'],
    },
    {
      path: '/settings',
      component: 'SettingsLayoutContainer',
      label: 'navigation.routeGroup.userSettings',
      hidden: true,
    },
    {
      path: '/hospitalizedPatientsByHospSrcId',
      component: 'HospitalizedPatientsByHospSrcIdContainer',
      label: 'navigation.routeGroup.hospitalizedPatientsByHospSrcId',
      paramsString: '/:hospitalizationSrcId',
      hidden: true,
    },
  ],
  dynamicRoutes: [
    {
      id: 'patient',
      path: '/hospitalizedPatients',
      paramsString: '/:hospitalizationId/document?/:documentId?',
      component: 'HospitalizationDetailLayoutContainer',
      iconClass: 'fa-user',
      label: '?',
      redirectOnCloseRoute: '/hospitalizedPatients',
    },
    {
      id: 'hospitalizedPatientV2',
      path: '/hospitalizedPatients/v2',
      paramsString: '/:hospitalizationId/document?/:documentId?',
      component: 'HospitalizationDetailLayoutV2',
      iconClass: 'fa-user',
      label: '?',
      redirectOnCloseRoute: '/hospitalizedPatients',
    },
  ],
  dynamicGroups: [
    {
      ids: ['patient', 'hospitalizedPatientV2'],
      label: 'navigation.routeGroup.openedCases',
    },
  ],
};
